<!DOCTYPE html>
<!-- <div class="gototop" (click)="pageScroller()"><img src="../../../assets/icon/gototop.svg" /></div> -->
<app-top-header></app-top-header>

<div class="chatbot-icon" (click)="openChatBot()" *ngIf="showWidget">
  <ion-icon name="chatbubbles"></ion-icon>
</div>
<ion-content #pageTop *ngIf="syndicatePageData$ | async as syndicateDetails else loading" (click)="touch()">
  <div [ngClass]=" showWidgetToolTip ? 'bg-highlighted-overlay' : ''"></div>
  <div *ngIf=" !loadingStart else loading" (click)="autoplay=true">
    <div class="page-background-blue common-page-padding">

      <br>
      @if ((banner_status || syndicatePending) && !syndicateLoaded?.length) {
      <div class="syndicateLoading">
        <ion-row>
          <ion-col size="7" class="ion-no-padding">
            <h3>Your tickets are being generated...</h3>
            <h4>Come back later to see your numbers</h4>
          </ion-col>
          <ion-col size="5">
            <ng-lottie height="14.5vh" width="100%" [options]="options"></ng-lottie>
          </ion-col>
        </ion-row>
        <div class="shadowOne"></div>
        <div class="shadowThree"></div>
      </div>
      }

      <ion-grid class="ion-no-padding">
        <!-- widget slider -->
        <div>
          <h3 class="extra">{{extras}}</h3>
          <div class="miniwidget" *ngIf="showAllMiniWidget">
            <div class="previous-checks-coach-mark" *ngIf="showPreviousCheck && showPreviousCheckCouch">
              <div class="coach-text">{{ 'Syndicatepage.tooltip' | translate }}</div>
            </div>
            <swiper [config]="slideOpts" class="swiper-tiles">
              <ng-template swiperSlide let-prevCheck [ngIf]="checkWinnings$ | async"
                class="slide order1 previous-checks-widget slidewidget" *ngIf="showPreviousCheck">
                <app-syndicate-previous-checks
                  (showPreviousExpandViewEvent)="showPreviousExpandView($event)"></app-syndicate-previous-checks>
              </ng-template>

              <!-- Lucky Number mini widget-->
              <ng-template swiperSlide class="slide order2 slidewidget"
                *ngIf="showMiniWidget && LnRemainingBalance > 0">
                <ion-card [ngStyle]="{'background-color': widgetDetails?.background_color}" class="lucky-slider"
                  (click)="showExpandView()">
                  <ion-icon name="information-circle-outline" class="i-info" (click)="sliderShow($event)">
                  </ion-icon>
                  <div class="first-card" *ngIf="widgetDetails?.icon_url">
                    <img src="../../../{{widgetDetails?.icon_url}}" alt="lucky number" />
                  </div>
                  <div class="lucky-title">
                    <h5>{{widgetDetails?.title}}</h5>
                  </div>
                  <div class="lucky-subtitle">
                    <h6>{{widgetDetails?.subtitle}}</h6>
                  </div>
                </ion-card>
                <div *ngIf="showWidgetToolTip" class="custom-tooltip">{{this.toolTipMsg}}</div>
              </ng-template>

              <ng-template swiperSlide class="slide order2 slidewidget"
                *ngIf="showMiniWidget && LnRemainingBalance === 0">
                <!-- <div class="lucky-slider-first" *ngIf="widgetDetails?.remaining == 0"> -->
                <ion-card [ngStyle]="{'background-color': widgetDetails?.background_color}" class="lucky-slider"
                  (click)="showExpandView(); onClick('lucky_numbers_widget');">
                  <ion-icon name="information-circle-outline" class="i-info" (click)="sliderShow($event)">
                    <!--  (click)="showTooltip1('Tap here to add Lucky Numbers to your tickets')" -->
                  </ion-icon>
                  <div class="first-card">
                    <img src="../../../{{widgetDetails?.icon_url}}" alt="" />
                  </div>
                  <div class="lucky-title">
                    <h5>{{widgetDetails?.title}}</h5>
                  </div>
                  <div class="lucky-subtitle">
                    <h6>{{widgetDetails?.subtitle}}</h6>
                  </div>
                  @if (luckyNumberStatus) {
                  <ng-lottie [options]="luckyNumberOptions" class="luckyWidget-animation"
                    (click)="onClick('lucky_numbers_widget'); showExpandView();"
                    (animationCreated)="updateAnimationStatus('lucky_numbers_widget', luckyNumberDuration);"></ng-lottie>
                  }
                </ion-card>
                <div *ngIf="showWidgetToolTip" class="custom-tooltip">{{this.toolTipMsg}}</div>
                <!-- </div> -->
              </ng-template>
              <!-- Lucky Number mini widget-->

              <ng-template swiperSlide class="order3 slidewidget"
                *ngIf="showJackpotMiniWidget && triggerActiveCount == 0">
                <ion-card *ngIf="triggerActiveCount == 0" class="lucky-slider" (click)="showJackpotExpandView($event)">
                  <!--<div [ngClass]="showWidgetToolTip ? 'highlighted-overlay': ''" ></div>-->
                  <ion-icon name="information-circle-outline" class="i-info" (click)="opentriggerInfo($event)">
                  </ion-icon>
                  <div class="trigger-mini-card">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/jackpot_trigger%2Fjackpot-widget_800x800.png?alt=media"
                      alt="" />
                  </div>
                  <div class="trigger-mini-title">
                    <h5>{{'Syndicatepage.JackpotTriggers' | translate}}</h5>
                  </div>
                  <div class="trigger-mini-subtitle">
                    <h6>{{triggerActiveCount}} {{'Syndicatepage.active' | translate}}</h6>
                  </div>
                  @if (jackpotStatus) {
                  <ng-lottie [options]="jackpotOptions" class="luckyWidget-animation"
                    (click)="onClick('jackpot_triggers_widget');"
                    (animationCreated)="updateAnimationStatus('jackpot_triggers_widget', jackpotDuration);"></ng-lottie>
                  }
                </ion-card>
              </ng-template>

              <!-- Gold Ring mini widget-->
              <ng-template swiperSlide class="order3 slidewidget" *ngIf="showGoldRingMiniWidget">
                <app-syndicate-goldring [goldRingWidgetDetails]="goldRingWidgetDetails"
                  [goldRingToolTipMsg]="goldRingToolTipMsg" [showGoldRingToolTip]="showGoldRingToolTip"
                  (picktingsOpenEvent)="picktings_open()" (showGoldExpandViewOpenEvent)="showGoldExpandView()"
                  (grToolTipEvent)="grToolTip()"></app-syndicate-goldring>
              </ng-template>
              <!-- Gold Ring mini widget-->

              <ng-template swiperSlide class="slide order3 slidewidget"
                *ngIf="showJackpotMiniWidget && triggerActiveCount >= 1">
                <app-syndicate-jackpot-trigger [childProperty1]="triggerActiveCount"
                  (showJackpotExpandViewEvent)="showJackpotExpandView($event)"
                  (opentriggerInfoEvent)="opentriggerInfo($event)"></app-syndicate-jackpot-trigger>

              </ng-template>
            </swiper>
          </div>
        </div>
        <!-- end widget slider -->

        <!-- expanded View lucky widget -->
        <ion-card class="expd-card" *ngIf="showExpandWidget">
          <a (click)="shrinkWidget()" class="shrink-icon"><img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fshrink-icon_800x800.png?alt=media"
              alt="shrink icon" /></a>
          <ion-row class="lucky-title">
            <p>{{widgetDetails?.title}}</p>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fexpd-star.svg?alt=media"
              alt="" />
          </ion-row>
          <ion-row class="lucky-info">
            <p>{{lnWidgetdescription}}</p>
          </ion-row>
          <ion-card class="box-inbox">
            <p>{{widgetDetails?.used}}</p>
            <h6>{{widgetDetails?.remaining}}</h6>
          </ion-card>
          <button *ngIf="widgetDetails?.remaining" class="show" (click)="availableSyndicates()">{{showBtn}}</button>
        </ion-card>
        <!-- end expanded view lucky widget -->

        <!-- another expand view -->
        <ion-card class="expd-card ano-expd-card" *ngIf="showAvailableSyndicateWidget">
          <a (click)="closeExpandWidget()" class="shrink-icon">
            <img width="25px" src="../../../assets/icon/close-circle.png" alt="close icon" />
          </a>
          <ion-row class="lucky-title">
            <p>{{highlightLnTitle}}</p>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fexpd-star.svg?alt=media"
              alt="" />
          </ion-row>
          <ion-row class="lucky-info">
            <p>{{lnWidgetdescription}}</p>
          </ion-row>
        </ion-card>
        <!-- end another view -->
        <!-- start Previous Expand on syndicate page -->
        <ion-card class="prv-card" *ngIf="showPreviousExpandWidget && !showAllMiniWidget">
          <ion-row class=" ion-padding-start ion-padding-end ion-align-items-center">
            <p class="prv-title">{{'Syndicatepage.PreviousChecks' | translate}}</p>
            <img style="display: none;" src="../../../assets/icon/union.svg" alt="" class="pev-img" />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fshrink-icon_800x800.png?alt=media"
              alt="" class="pev-shrink-icon ion-padding-end" (click)="closePreviousExpandWidget()" />
            <!--expTriggerView()-->
          </ion-row>
          <swiper [config]="SliderOptions" #swiperSliders (swiper)="setSwiperInstance($event)"
            (touchmove)="autoplay=false" (mouseover)="autoplay=false" (mouseout)="autoplay=true">

            <ng-template swiperSlide
              *ngIf="
            CheckWinningsStatsMessage?.lang?.[languageCode]?.random_message[CurrentCheckWinningsStats?.section?.[1]?.random_message]">
              <ion-card class="inner-card pad-5 ion-align-items-center light-bg inner-flex">
                <ion-row class="ion-align-items-center col-grid">
                  <ion-col size="2" class="info-col">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/mini_widgets%2F!icon.png?alt=media&token=c9fddb73-2159-4c9e-8347-41d363253eea"
                      alt="" class="offer-logo" />
                  </ion-col>
                  <ion-col size="7">
                    <ion-row class="inner-desc1">
                      {{'Syndicatepage.did_you_know' | translate}}
                    </ion-row>
                    <ion-row class="inner-desc2"
                      [innerHTML]="replace(CheckWinningsStatsMessage?.lang?.[languageCode]?.random_message[CurrentCheckWinningsStats?.section?.[1]?.random_message])">
                    </ion-row>
                  </ion-col>
                </ion-row>
              </ion-card>
            </ng-template>

            <ng-template swiperSlide *ngIf="CurrentCheckWinningsStats?.section">
              <ion-card class="inner-card ion-align-items-center light-bg  summary-wraper">
                <ion-row class="ion-align-items-center col-grid ion-padding">
                  <ion-col size="4" class="info-col">
                    <h4>{{'Syndicatepage.total_wins' | translate}}</h4>
                    <p>{{CurrentCheckWinningsStats?.section?.[2]?.total_win}}</p>
                  </ion-col>
                  <ion-col size="4" class="info-col border-lr">
                    <h4>{{'Syndicatepage.total_points' | translate}}</h4>
                    <p>{{CurrentCheckWinningsStats?.section?.[2]?.total_points}}</p>
                  </ion-col>
                  <ion-col size="4" class="info-col">
                    <h4>{{'Syndicatepage.total_prizes' | translate}}</h4>
                    <p>{{CurrentCheckWinningsStats?.section?.[2]?.total_prizes}}</p>
                  </ion-col>
                </ion-row>
              </ion-card>
            </ng-template>
            <ng-template swiperSlide>
              <ion-card class="inner-card ion-align-items-center light-bg graph-wraper">
                <ion-row class="ion-align-items-center col-grid pad">
                  <ion-col size="12" class="graph-col">
                    <div>
                      <canvas id="linechart" #lineCanvas></canvas>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-card>
            </ng-template>
          </swiper>
          <span>
            <ion-row class="ion-align-items-center">
              <ng-template let-prevCheck [ngIf]="checkWinnings$ | async">
                <div style="width: 100%;" *ngIf="prevCheck && prevCheck?.length > 0">
                  @if (previousCheckLinkStatus) {
                  <ng-lottie [options]="previousCheckLinkOptions" class="previousCheckLink-animation"
                    (click)="onClick('see_previous_checks_link'); openListOfChecks(prevCheck);"
                    (animationCreated)="updateAnimationStatus('see_previous_checks_link', previousCheckLinkDuration);"></ng-lottie>
                  }
                  <a class="bot-link pulse-a"
                    (click)="openListOfChecks(prevCheck)">{{'Syndicatepage.see_previous_checks' | translate}}</a>
                </div>
              </ng-template>
            </ion-row>
          </span>
        </ion-card>

        <!-- start jackpot trigger on syndicate page -->
        <ion-card class="trigger-card" *ngIf="showJackpotExpandWidget && triggerActiveCount">
          <ion-row class="ion-align-items-center">
            <p class="trigger-title">{{'Syndicatepage.JackpotTriggers' | translate}}</p>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Ftrigger-energy_800x800.png?alt=media"
              alt="" class="trigger-img" />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fshrink-icon_800x800.png?alt=media"
              alt="" class="trigger-shrink-icon" (click)="closeJackpotExpandWidget()" />
            <!--expTriggerView()-->
          </ion-row>
          <ion-row class="exp-trigger-desc">
            <p class="reserve-jackpot trigger-desc" [innerHTML]="jackpotTriggerData?.description | safeHtml"></p>
          </ion-row>
          <ion-row class="exp-trigger-desc">
            <p class="trigger-desc">
              {{ (triggerActiveCount &gt;= 1 ? 'jackpot-trigger-widget.active_desc' : 'jackpot-trigger-widget.Dont
              Miss') | translate }}
            </p>
          </ion-row>
          <swiper [config]="SliderOptions" class="slides-fortrigger" (swiper)="setSwiperInstant($event)">
            <ng-template swiperSlide>
              <ion-card class="inner-card ion-align-items-center claim-slide">
                <ion-row class="ion-align-items-center">
                  <ion-col size="8">
                    <ion-row class="claim-desc">
                      {{'jackpot-trigger-widget.Boost Chances' | translate}}
                    </ion-row>
                  </ion-col>
                  <ion-col size="4" class="ion-align-items-center toggle-col">
                    <button class="claim-btn" (click)="navigateToStore()">{{'jackpot-trigger-widget.Claim' |
                      translate}}</button>
                  </ion-col>
                </ion-row>
              </ion-card>
            </ng-template>
            <ng-template swiperSlide *ngFor="let data of jackpotTrigger$ | async">
              <ion-card class="inner-card ion-align-items-center"
                [ngClass]="data?.jackpot_name === 'EuroMillions' ? 'inner-card-euro' : data?.jackpot_name === 'Lotto' ? 'inner-card-lotto' : 'inner-card-powerball'">
                <ion-row class="ion-align-items-center three-col">
                  <ion-col size="2" class="info-col">
                    <img src="{{data?.jackpot_image}}" alt="" class="offer-logo" />
                  </ion-col>
                  <ion-col size="7">
                    <ion-row class="inner-desc1"
                      [ngClass]="data?.jackpot_name === 'EuroMillions' ? 'blue-section' : data?.jackpot_name === 'Lotto' ? 'red-section' : 'brown-section'">
                      {{data?.jackpot_name}}
                      <!-- {{currencySymbol}}{{data?.int_jackpot?.[preferredCurrency] ?
                        data?.int_jackpot?.[preferredCurrency] :data?.jackpot}} -->
                    </ion-row>
                    <ion-row class="inner-desc2 ion-text-start">
                      {{data?.lines}} {{'Syndicatepage.extra_lines_when' | translate}}
                      <!-- <span
                        [ngClass]="data?.jackpot_name === 'EuroMillions' ? 'blue-section' : data?.jackpot_name === 'Lotto' ? 'red-section' : 'brown-section'">
                        {{currencySymbol}}{{data?.int_price?.[preferredCurrency].toFixed(2) ?
                        data?.int_price?.[preferredCurrency].toFixed(2) : data?.price.toFixed(2)}}</span> -->

                      {{'Syndicatepage.jackpot_reaches' | translate}} <span
                        [ngClass]="data?.jackpot_name === 'EuroMillions' ? 'blue-section' : data?.jackpot_name === 'Lotto' ? 'red-section' : 'brown-section'">
                        {{currencySymbol}}{{data?.jackpot}}</span>
                    </ion-row>
                  </ion-col>

                  <ion-col size="3" class="ion-align-items-center toggle-col">
                    <label class="switch">
                      <input type="checkbox" [checked]="isToggled" (click)="showTriggerPopup(data)" />
                      <span class="slider round"></span>
                    </label>
                    <!-- <ion-toggle class="toggle-class" [(ngModel)]="isToggled" (click)="showTriggerPopup(data)"></ion-toggle> -->
                  </ion-col>
                </ion-row>
              </ion-card>
            </ng-template>
          </swiper>
        </ion-card>

        <!--- gold card Expand widget-->
        <ion-card class="exp-trigger-ano-view gold-expand fix-height" *ngIf="showGoldExpandWidget">
          <ion-row class="ion-align-items-center">
            <p class="trigger-title">{{goldRingWidgetDetails?.title}}</p>
            <img src="../../../assets/icon/upicon.png" alt="" class="trigger-img" />
            <img src="../../../assets/icon/shrink-icon.png" alt="" class="trigger-shrink-icon"
              (click)="closeGoldExpandWidget()" />
            <!--- 
          close icon for 2nd state
          <img src="../../../assets/icon/close-circle.png" alt="close-icon" class="trigger-shrink-icon" />  -->


          </ion-row>
          <p class="exp-jackpot-desc">{{grWidgetdescription}}</p>
          <!-- for golden -->
          <ion-card [ngClass]="goldRingWidgetDetails?.remaining ? 'gray-box' : 'gold-box'">
            <h3><small>{{goldRingWidgetDetails?.used}} {{goldRingWidget?.used}} </small><br>
              {{goldRingWidgetDetails?.remaining}} {{goldRingWidget?.remaining}}</h3>
          </ion-card>
          <h4 class="link" *ngIf="goldRingWidgetDetails?.remaining" (click)="goldRingsAvailableSyndicates()">
            {{goldRingWidget?.gr_show_btn}}</h4>
        </ion-card>

        <!-- Gold ring another expand view -->
        <ion-card class="exp-trigger-ano-view gold-expand" *ngIf="showGoldRingAvailableSyndicateWidget">
          <ion-row class="ion-align-items-center">
            <p class="trigger-title">{{goldRingWidgetDetails?.title}}</p>
            <img src="../../../assets/icon/upicon.png" alt="" class="trigger-img" />
            <a (click)="closeGoldExpandWidget()">
              <img src="../../../assets/icon/close-circle.png" alt="close icon" class="trigger-shrink-icon" />
            </a>
          </ion-row>
          <p class="exp-jackpot-desc">{{grWidgetdescription}}</p>
        </ion-card>
        <!-- Gold ring  end another view -->

        <!--another expanded view  -->
        <ion-card class="exp-trigger-ano-view" *ngIf="showJackpotExpandWidget  && !triggerActiveCount">
          <ion-row class="ion-align-items-center">
            <p class="trigger-title">{{'Syndicatepage.JackpotTriggers' | translate}}</p>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Ftrigger-energy_800x800.png?alt=media"
              alt="" class="trigger-img" />
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fshrink-icon_800x800.png?alt=media"
              alt="" class="trigger-shrink-icon" (click)="closeJackpotExpandWidget()" />
          </ion-row>
          <ion-row class="exp-trigger-desc">
            <p class="reserve-jackpot trigger-desc" [innerHTML]="jackpotTriggerData?.description | safeHtml"></p>
          </ion-row>
          <p class="exp-jackpot-desc" *ngIf="reamainingJackpotTriggers <= 0">{{
            jackpotWidgetTranslatedData?.inactive_desc_1 | translate }}</p>
          <ion-row class="exp-trigger-desc" *ngIf="reamainingJackpotTriggers > 0">
            <p class="trigger-desc">
              {{ 'jackpot-trigger-widget.Dont Miss' | translate }}
            </p>
          </ion-row>
          <ion-card class="inner-card ion-align-items-center claim-slide">
            <ion-row class="ion-align-items-center">
              <ion-col size="8">
                <ion-row class="claim-desc">
                  {{ 'jackpot-trigger-widget.Boost Chances' | translate }}
                </ion-row>
              </ion-col>
              <ion-col size="4" class="ion-align-items-center toggle-col">
                <button class="claim-btn" (click)="navigateToStore()">{{ 'jackpot-trigger-widget.Claim' | translate
                  }}</button>
              </ion-col>
            </ion-row>
          </ion-card>
        </ion-card>

        <div id="ct-nat-synd"></div>

        <!-- check winnings wrapper for showing potential winnings -->
        <div class="check-winnings-wrapper">
          <div>{{ syndicateData?.potential_winnings?.potential_winnings }} <strong class="winnings-margin-right">{{
              syndicateData?.potential_winnings?.winnings }} </strong></div>
          <div *ngIf="syndicateCount > 0">
            |<a [routerLink]="['/' + syndicateData?.potential_winnings?.more_lines_destination?.split('?')?.[0]]"
              [queryParams]="{ tp1: syndicateData?.potential_winnings?.more_lines_destination?.split('tp1=')?.[1] }"
              class="winnings-margin underline-decoration">{{ syndicateData?.potential_winnings?.more_lines }}</a>
            <strong>{{ syndicateData?.potential_winnings?.more_wins }}</strong>
          </div>
          <div *ngIf="syndicateCount === 0">
            <span class="winnings-margin">|</span>
            {{ syndicateData?.potential_winnings?.playing_euromillions }}
            <a [routerLink]="['/' + syndicateData?.potential_winnings?.play_now_destination?.split('?')?.[0]]"
              [queryParams]="{ tp1: syndicateData?.potential_winnings?.play_now_destination?.split('tp1=')?.[1] }"
              class="underline-decoration">{{ syndicateData?.potential_winnings?.play_now }}</a>
          </div>
        </div>
        <!-- end check winnings wrapper -->
        <div class="help-link">
          <img src="../../../assets/images/help_notification_icon.svg" alt="notification-icon">
          <a [routerLink]="['/account/helpSupport']" (click)="NeedHelpMixPanel()">{{'Syndicatepage.Need_help' |
            translate}}</a>
        </div>
        @if (isPushNotification()) {
          <app-push-notification-banner [notificationData]="inlineNotificationDetails"></app-push-notification-banner>
          } @else if (isAddHomeScreen()) {
          <app-add-home-screen-banner [notificationData]="inlineNotificationDetails"></app-add-home-screen-banner>
          } @else {
        @if (inlineNotificationDetails && inlineNotificationDetails?.content) {
        <div class="push-notification"
          [ngClass]="{ 'main-head-notification': inlineNotificationDetails?.style === 'promotional' }"
          [style.background]="inlineNotificationDetails?.style === 'promotional' ? inlineNotificationDetails?.background : null">
          <div class="notification-header">
            <div class="header">
              <div class="bell-wrapper">
                <img [src]="getIconUrl(inlineNotificationDetails?.icon_url)" alt="Bell icon" class="inline_icon_width" />
              </div>
              <p [innerHTML]="inlineNotificationDetails?.content?.title"></p>
            </div>
            <img
              [src]="'assets/icon/' + (inlineNotificationDetails?.style === 'promotional' ? 'close-circle.svg' : 'close-gray.svg')"
              alt="Close Notification" class="close-notify" (click)="feedBackDismiss()" />
          </div>
          <div class="notify-content">
            <div>
              <p class="content-title title-description" [innerHTML]="inlineNotificationDetails?.content?.line_1"></p>
              <p class="content-subtitle" [innerHTML]="inlineNotificationDetails?.content?.line_2"></p>
            </div>
            <button class="active-btn" type="button" [ngClass]="{ 'with-countdown': countdownSeconds }"
              [disabled]="isVoucherClaimedSignal()"
              (click)="handleInlineNotification(inlineNotificationDetails)">
    
              {{ inlineNotificationDetails?.content?.button_label }}
              @if(countdownSeconds) {
              <span class="timer-text">{{ voucherNotificationService.claimTimerDisplay }}</span>
              }
            </button>
            @if (countdownSeconds) {
            <countdown-timer [seconds]="countdownSeconds"
              (formattedTime)="voucherNotificationService.claimTimerDisplay = $event" (countdownFinished)="handleCountdownFinish()">
            </countdown-timer>
          }
          </div>
        </div>
        }
        }
        <!-- start no-active-state -->
        <div class="no-active-state" *ngIf="!syndicateLoaded?.length && !syndicatePending && !banner_status && syndicatePageOffer$ |async as card">
          <h3 class="title">{{ syndicateData?.syndicate_list?.empty_state_message }}</h3>
          <img src="../../../assets/icon/em-logo.png" alt="euro-logo" class="millions-logo" />
          <div class="bottom-wrapper">
            <h4 class="detail-title">{{lottryDescription$ | async}}</h4>
            <p class="detail-text">{{card?.content[languageCode]?.title_lines}}</p>
            <button class="btn-join"
              (click)="goToCheckout(card?.offer_id)">{{card?.content[languageCode]?.button_label}}</button>
          </div>
        </div>
        <!-- end no-active-state -->
        <div *ngIf="syndicateLoaded && syndicateLoaded?.length" class="card-wrapper">
          <div *ngFor="let syndicate of syndicateLoaded | slice: 0:cardLimit; let i=index; trackBy: trackById">
            <app-syndicate-card [syndicate]="syndicate" [goldRingWidgetDetails]="goldRingWidgetDetails"
              (openSyndicateSettingEvent)="openSyndicateSetting($event)"
              (updateProductForManagedSyndicateEvent)="updateProductForManagedSyndicate($event)"
              (clickOfferBannerEvent)="clickOfferBanner($event)" (openTicketsEvent)="openTickets($event)"
              (routeToCreateSyndicateEvent)="routeToCreateSyndicate($event)"
              (getPrivateSyndicateEvent)="getPrivateSyndicate($event)"
              (showPaymentOptionsEvent)="showPaymentOptions($event)" (chatNowEvent)="chatNow($event)"
              (openSyndicateMembersEvent)="openSyndicateMembers($event)"
              [preferredCurrency]="preferredCurrency" [currencySymbol]="currencySymbol"
              >
            </app-syndicate-card>
          </div>
          @if (showText) {
            <p class="syndicateMsg">No More Syndicates</p>
          }
        </div>
        <!-- Scrolling Event Trigger and spinner -->
        <ion-infinite-scroll threshold="20%" (ionInfinite)="loadMoreSyndicates($event, syndicateDetails)" #loadSyndicate
          *ngIf="syndicateLoaded?.length">
          <ion-infinite-scroll-content loadingSpinner="circular" class="scroll-space">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
        <ion-row *ngIf="(isWinning$ | async) && syndicateDetails?.length > 0" class="row-winnings-floating">
          <ion-button expand="block" class="action-btn-large btn-winnings-floating" type="submit"
            [disabled]="checkWinningsInFlight$ | async"
            (click)="openCheckWinnings()">
            {{'Syndicatepage.Check my winnings' |translate}}
          </ion-button>
        </ion-row>
      </ion-grid>
    </div>
  </div>
  <ng-template #loading>
    <app-in-progress-animation></app-in-progress-animation>
  </ng-template>
</ion-content>

<ng-template #loading>
  <app-in-progress-animation type="syndicate"></app-in-progress-animation>
</ng-template>
